export default __webpack_public_path__ + "static/media/casino-hover.c48a184a.webp";